import { render, staticRenderFns } from "./MaterialLifecycle.vue?vue&type=template&id=81d3f6a2&scoped=true"
import script from "./MaterialLifecycle.vue?vue&type=script&lang=js"
export * from "./MaterialLifecycle.vue?vue&type=script&lang=js"
import style0 from "./MaterialLifecycle.vue?vue&type=style&index=0&id=81d3f6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d3f6a2",
  null
  
)

export default component.exports